import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_search",
  "use": "micro_search-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_search\"><path d=\"M4 0a4 4 0 0 1 3.16 6.453l2.694 2.693a.5.5 0 0 1-.638.765l-.07-.057L6.453 7.16A4 4 0 1 1 4 0Zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol